// extracted by mini-css-extract-plugin
export var dropdownButton = "_31-0";
export var fullWidthDropdownButton = "_31-1";
export var icon = "_31-3";
export var iconPlaceholder = "_31-2";
export var menuItemRow = "_31-9";
export var separator = "_31-e";
export var shortcutContainer = "_31-7";
export var shortcutContainerFilled = "_31-8";
export var shortcutIconLg = "_31-6";
export var shortcutIconMd = "_31-5";
export var shortcutIconSm = "_31-4";
export var submenuChevron = "_31-d";
export var submenuDropdown = "_31-a";
export var submenuTriggerRow = "_31-b";
export var submenuTriggerRowOpen = "_31-c";